import { useMemo } from 'react'
import { useAccessProjects, useAccessUsers, useDepartments } from './api'
import type { AccessProject, AccessUser, Department, Role } from './types'

export function useAccessLookups() {
  const users = useAccessUsers()
  const departments = useDepartments()
  const projects = useAccessProjects()

  return useMemo(() => {
    const userById = new Map<string, AccessUser>((users.data ?? []).map((u) => [u.id, u]))
    const departmentById = new Map<string, Department>((departments.data ?? []).map((d) => [d.id, d]))
    const projectById = new Map<string, AccessProject>((projects.data ?? []).map((p) => [p.id, p]))

    const userNames = (role: Role) => role.assignments.map((a) => userById.get(a.userId)?.name).filter((n): n is string => !!n)
    const targetNames = (role: Role) =>
      role.scopeTargets
        .map((id) => (role.scope === 'department' ? departmentById.get(id)?.name : projectById.get(id)?.name))
        .filter((n): n is string => !!n)

    return {
      users: users.data ?? [],
      departments: departments.data ?? [],
      projects: projects.data ?? [],
      userById,
      departmentById,
      projectById,
      userNames,
      targetNames,
      usersLoading: users.isLoading,
    }
  }, [users.data, users.isLoading, departments.data, projects.data])
}
